import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';

import { Modal } from '@common/components/modal';
import { Button } from '@common/components/button';
import * as AlertService from '@services/alert';
import { Group, Row } from '@common/components/form';
import { TextInputHookForm } from '@common/components/form/inputs/text';
import Label from '@common/components/form/label';

import { useThunkDispatch } from '@common/hooks';
import { saveAsTemplate } from '../../actions';

type FormPayload = {
  title: string;
};

type Props = {
  formId: string;
  onClose: () => void;
};

export const CreateTemplateForm = ({ formId, onClose }: Props) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(true);
  const thunkDispatch = useThunkDispatch();

  const { control, formState, handleSubmit } = useForm<FormPayload>({
    mode: 'all',
    defaultValues: {
      title: '',
    }
  });
  const { isValid } = formState;

  const onSave = handleSubmit(async (values) => {
    try {
      await thunkDispatch(saveAsTemplate(formId, values));
      AlertService.success(t('forms:create_template_success'));
      setShowModal(false);
    } catch (response: any) {
      AlertService.forStatus(response.status, {
        warning: t('forms:save_as_template_warning'),
        error: t('forms:save_as_template_error'),
      });
    }
  });

  return (
    <Modal
      size="small"
      show={showModal}
      title={t('forms:save_as_template')}
      onExited={onClose}
      content={(
        <Row>
          <Group>
            <Label text={t('forms:form_form_title')} />
            <Row>
              <TextInputHookForm
                name="title"
                placeholder={t('forms:form_form_title_placeholder')}
                control={control}
                rules={{ required: true }}
              />
            </Row>
          </Group>
        </Row>
      )}
      footerChildren={(
        <Button
          type="primary"
          onClick={onSave}
          disabled={!isValid}
        >
          {t('forms:save_template')}
        </Button>
      )}
    />
  );
};
